import type { Texture } from 'three';

interface TextureSource {
  width?: number;
  height?: number;
  naturalWidth?: number;
  naturalHeight?: number;
  videoWidth?: number;
  videoHeight?: number;
}

/**
 * three r185 types `Texture.image` as `unknown`, since the underlying source
 * can be an image, a video, a canvas or an ImageBitmap. Everywhere we touch it
 * we only read its dimensions, so narrow it in one place instead of casting at
 * each site.
 *
 * Which field carries the real size depends on the source: an <img> only
 * reports `naturalWidth` reliably (`width` follows layout), a <video> uses
 * `videoWidth`, and an ImageBitmap or canvas has plain `width`. Returns zeros
 * while a texture is still decoding — callers must treat that as "not ready"
 * rather than dividing by it.
 */
export const textureImage = (texture: Texture) => {
  const source = texture.image as TextureSource | null | undefined;

  return {
    width: source?.naturalWidth || source?.videoWidth || source?.width || 0,
    height: source?.naturalHeight || source?.videoHeight || source?.height || 0,
  };
};
